export default __webpack_public_path__ + "static/en-9429136f89a6fea52488392d7113741a.svg";